import { render, staticRenderFns } from "./FotoIBPList.vue?vue&type=template&id=4658e236"
import script from "./FotoIBPList.vue?vue&type=script&lang=js"
export * from "./FotoIBPList.vue?vue&type=script&lang=js"
import style0 from "./FotoIBPList.vue?vue&type=style&index=0&id=4658e236&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports